const illus01 = require("./illustration/illus01.png");
const illus02 = require("./illustration/illus02.png");
const illus03 = require("./illustration/illus03.png");
const illus04 = require("./illustration/illus04.png");
const illus05 = require("./illustration/illus05.png");
const illus06 = require("./illustration/illus06.png");
const illus07 = require("./illustration/illus07.png");
const illus08 = require("./illustration/illus08.png");
const illus09 = require("./illustration/illus09.png");
const illus10 = require("./illustration/illus10.png");
const illus11 = require("./illustration/illus11.png");
const illus12 = require("./illustration/illus12.png");
const illus13 = require("./illustration/illus13.png");
const illus14 = require("./illustration/illus14.png");
const illus15 = require("./illustration/illus15.png");
const illus16 = require("./illustration/illus16.png");
const illus17 = require("./illustration/illus17.png");

const penink01 = require("./penInk/penink01.png");
const penink02 = require("./penInk/penink02.png");
const penink03 = require("./penInk/penink03.png");
const penink04 = require("./penInk/penink04.png");
const penink05 = require("./penInk/penink05.png");
const penink06 = require("./penInk/penink06.png");

const sketch01 = require("./sketch/sketch01.png");
const sketch02 = require("./sketch/sketch02.png");
const sketch03 = require("./sketch/sketch03.png");
const sketch04 = require("./sketch/sketch04.jpg");
const sketch05 = require("./sketch/sketch05.jpg");
const sketch06 = require("./sketch/sketch06.png");
const sketch07 = require("./sketch/sketch07.png");
const sketch08 = require("./sketch/sketch08.png");
const sketch09 = require("./sketch/sketch09.png");
const sketch10 = require("./sketch/sketch10.png");
const sketch11 = require("./sketch/sketch11.jpg");
const sketch12 = require("./sketch/sketch12.gif");
const sketch13 = require("./sketch/sketch13.png");
const sketch14 = require("./sketch/sketch14.png");
const sketch15 = require("./sketch/sketch15.png");
const sketch16 = require("./sketch/sketch16.png");

const snake00 = require("./comics/snake/sn0.jpg");
const snake01 = require("./comics/snake/sn1.jpg");
const snake02 = require("./comics/snake/sn2.jpg");
const snake03 = require("./comics/snake/sn3.jpg");

const dk01 = require("./comics/darkest-knife/dk1.jpg");
const dk02 = require("./comics/darkest-knife/dk2.jpg");
const dk03 = require("./comics/darkest-knife/dk3.jpg");
const dk04 = require("./comics/darkest-knife/dk4.jpg");

const etc00 = require("./comics/etc/etc00.png");
const etc01 = require("./comics/etc/etc01.png");
const etc02 = require("./comics/etc/etc02.png");
const etc03 = require("./comics/etc/etc03.png");
const etc04 = require("./comics/etc/etc04.png");
const etc05 = require("./comics/etc/etc05.png");
const etc06 = require("./comics/etc/etc06.png");
const etc07 = require("./comics/etc/etc07.png");
const etc08 = require("./comics/etc/etc08.png");
const etc09 = require("./comics/etc/etc09.png");

export const illusArray = [illus01, illus02, illus03, illus04, illus05, illus06, illus07, illus08, illus09, illus10, illus11, illus12, illus13, illus14, illus15, illus16, illus17].map(a => a.default);
export const peninkArray = [penink01, penink02, penink03, penink04, penink05, penink06].map(a => a.default);
export const sketchArray = [sketch01, sketch02, sketch03, sketch04, sketch05, sketch06, sketch07, sketch08, sketch09, sketch10, sketch11, sketch12, sketch13, sketch14, sketch15, sketch16].map(a => a.default);
export const snakeArray = [snake00, snake01, snake02, snake03].map(a => a.default);
export const dkArray = [dk01, dk02, dk03, dk04].map(a => a.default);
export const etcArray = [etc00, etc01, etc02, etc03, etc04, etc05, etc06, etc07, etc08, etc09].map(a => a.default);